import axios from 'axios'

import config from '../../config'
import consts from '../../util/consts'
import action, { actionFailed } from '../../util/action'
import createAsyncConst from '../../util/createAsyncConst'

export const FETCH_TECHNICAL_ABSENCES_RELATORY_INIT = createAsyncConst(
  'FETCH_TECHNICAL_ABSENCES_RELATORY_INIT'
)
export const MAKE_TECHNICAL_ABSENCES_RELATORY = createAsyncConst(
  'MAKE_TECHNICAL_ABSENCES_RELATORY'
)

export function fetchTechnicalAbsencesRelatoryInit(
  page,
  filters = [],
  rows = consts.DEFAULT_PAGINATION
) {
  return dispatch => {
    dispatch(action(FETCH_TECHNICAL_ABSENCES_RELATORY_INIT.ACTION))
    return axios
      .get(`${config.API_URL}/technical-absence`, {
        params: {
          ...filters,
          rows: rows || consts.DEFAULT_PAGINATION,
          page: page || 1,
        },
      })
      .then(resp => {
        dispatch(
          action(FETCH_TECHNICAL_ABSENCES_RELATORY_INIT.SUCCESS, {
            data: resp.data,
            filters: filters,
          })
        )
        return resp
      })
      .catch(e =>
        dispatch(actionFailed(FETCH_TECHNICAL_ABSENCES_RELATORY_INIT, e))
      )
  }
}

export function makeRelatory(data) {
  return dispatch => {
    return axios({
      url: `${config.API_URL}/technical-absence`,
      method: 'GET',
      responseType: 'blob',
      headers: { Accept: 'application/vnd.ms-excel' },
      params: {
        ...data,
        download: true,
      },
    })
      .then(resp => {
        const url = window.URL.createObjectURL(new Blob([resp.data]))
        const link = document.createElement('a')

        link.href = url
        link.setAttribute('download', 'technical_absences_report.xlsx')
        document.body.appendChild(link)
        link.click()
        return resp
      })
      .catch(e => dispatch(actionFailed(MAKE_TECHNICAL_ABSENCES_RELATORY, e)))
  }
}

export function clearFilter() {
  return { type: 'CLEAR_ACTION_TECHNICAL_ABSENCES' }
}
